(function () {
  'use strict';

  var refreshId = 0;
  var refreshTimer = null;
  var observer = null;
  var inFlight = false;
  var lastApplied = 0;

  /* ---------- loader styles ---------- */

  function injectStyles() {
    if (document.getElementById('cart-pair-loader-styles')) return;
    var style = document.createElement('style');
    style.id = 'cart-pair-loader-styles';
    style.textContent =
      '[data-cart-pair-it-with]{position:relative;}' +
      '[data-cart-pair-it-with].is-pair-loading [data-cart-pair-it-with-content]{opacity:.35;pointer-events:none;transition:opacity .15s ease;}' +
      '[data-cart-pair-it-with].is-pair-loading::after{content:"";position:absolute;top:50%;left:50%;width:22px;height:22px;margin:-11px 0 0 -11px;border:2px solid rgba(0,0,0,.15);border-top-color:rgba(0,0,0,.7);border-radius:50%;animation:pairSpin .7s linear infinite;z-index:2;}' +
      '@keyframes pairSpin{to{transform:rotate(360deg);}}';
    document.head.appendChild(style);
  }

  function setLoading(on) {
    var wrapper = getWrapper();
    var container = getContainer();
    if (!wrapper || !container) return;
    // Agar abhi kuch dikh hi nahi raha to loader mat dikhao (flash se bachne ke liye)
    if (on && !container.innerHTML.trim()) return;
    wrapper.classList.toggle('is-pair-loading', !!on);
  }

  /* ---------- helpers ---------- */

  function getContainer() {
    return document.querySelector('[data-cart-pair-it-with-content]');
  }

  function getWrapper() {
    return document.querySelector('[data-cart-pair-it-with]');
  }

  function fetchSection() {
    var url = window.location.pathname + '?section_id=drawer-cart&_=' + Date.now();
    return fetch(url, { cache: 'no-store', headers: { 'X-Pair-Self': '1' } })
      .then(function (r) {
        if (!r.ok) throw new Error('Section fetch failed');
        return r.text();
      })
      .then(function (html) {
        return new DOMParser().parseFromString(html, 'text/html');
      });
  }

  function getCartPairProducts() {
    var container = getContainer();
    if (!container) return [];
    var el = container.querySelector('#cart-pair-products-json');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  /* ---------- pair section render ---------- */

  function toggleWrapper() {
    var container = getContainer();
    var wrapper = getWrapper();
    if (!container || !wrapper) return;
    wrapper.style.display = container.innerHTML.trim() ? '' : 'none';
  }

  function applyPair(doc) {
    var container = getContainer();
    if (!container) return;

    var newContent = doc.querySelector('[data-cart-pair-it-with-content]');
    container.innerHTML = newContent ? newContent.innerHTML.trim() : '';

    lastApplied = Date.now();
    setLoading(false);
    toggleWrapper();
    initButtons();
  }

  function refreshPair() {
    var id = ++refreshId;
    inFlight = true;
    setLoading(true);

    fetchSection()
      .then(function (doc) {
        if (id !== refreshId) return; // purana response ignore karo
        applyPair(doc);
      })
      .catch(function (err) {
        console.error('Cart pair refresh error', err);
        setLoading(false);
      })
      .then(function () {
        if (id === refreshId) inFlight = false;
      });
  }

  function scheduleRefresh() {
    // Agar abhi abhi refresh ho chuka hai ya chal raha hai to dobara fetch na karo
    if (inFlight || Date.now() - lastApplied < 800) return;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshPair, 50);
  }

  /* ---------- buttons ---------- */

  function initButtons() {
    var container = getContainer();
    if (!container) return;

    var products = getCartPairProducts();

    container.querySelectorAll('[data-js-cart-pair-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(btn.getAttribute('data-variant-id'), btn);
      });
    });

    container.querySelectorAll('[data-js-cart-pair-view]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var item = btn.closest('.cart-pair-item');
        var productId = parseInt(item.getAttribute('data-cart-pair-product-id'), 10);
        var productData = products.find(function (p) { return p.id === productId; });
        if (productData) openDrawer(productData);
      });
    });
  }

  /* ---------- add to cart ---------- */

  function addToCart(variantId, button) {
    button.disabled = true;
    setLoading(true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Pair-Self': '1'
      },
      body: 'id=' + variantId + '&quantity=1'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add failed');
        return r.json();
      })
      .then(function () {
        updateCartDrawer();
      })
      .catch(function (err) {
        console.error('Cart pair add error', err);
        button.disabled = false;
        setLoading(false);
      });
  }

  function updateCartDrawer() {
    var drawer = document.getElementById('site-cart-sidebar');
    if (!drawer) {
      window.location.reload();
      return;
    }

    var id = ++refreshId;
    inFlight = true;

    fetchSection()
      .then(function (doc) {
        var newCartForm = doc.querySelector('#site-cart-sidebar .cart-form');
        var oldCartForm = drawer.querySelector('.cart-form');
        if (newCartForm && oldCartForm) {
          oldCartForm.innerHTML = newCartForm.innerHTML;
        }

        var newFooter = doc.querySelector('#site-cart-sidebar .sidebar__footer');
        var oldFooter = drawer.querySelector('.sidebar__footer');
        if (newFooter && oldFooter) {
          oldFooter.innerHTML = newFooter.innerHTML;
        }

        var newHeader = doc.querySelector('#site-cart-sidebar .sidebar__header');
        var oldHeader = drawer.querySelector('.sidebar__header');
        if (newHeader && oldHeader) {
          oldHeader.innerHTML = newHeader.innerHTML;
        }

        var countEl = doc.querySelector('[data-header-cart-count]') || doc.querySelector('[data-cart-count]');
        if (countEl) {
          document.querySelectorAll('[data-header-cart-count], [data-cart-count]').forEach(function (el) {
            el.textContent = countEl.textContent;
          });
        }

        if (id === refreshId) applyPair(doc);

        if (drawer.classList.contains('cart-is-empty') && doc.querySelector('#site-cart-sidebar:not(.cart-is-empty)')) {
          drawer.classList.remove('cart-is-empty');
        }

        drawer.show();
      })
      .catch(function () {
        window.location.reload();
      })
      .then(function () {
        if (id === refreshId) inFlight = false;
      });
  }

  /* ---------- details drawer ---------- */

  function openDrawer(productData) {
    var drawer = document.getElementById('pair-details-drawer');
    if (!drawer) return;

    var titleEl = drawer.querySelector('[data-pair-drawer-title]');
    var contentEl = drawer.querySelector('[data-pair-drawer-content]');
    if (!contentEl) return;

    if (titleEl) titleEl.textContent = productData.title;

    var galleryHtml = '<div class="pair-details__gallery">';
    productData.images.forEach(function (img) {
      galleryHtml += '<img src="' + img.src + '" alt="' + (img.alt || '') + '" loading="lazy">';
    });
    galleryHtml += '</div>';

    var variantsHtml = '';
    if (productData.variants && productData.variants.length > 1) {
      variantsHtml = '<div class="pair-details__variants">';
      productData.variants.forEach(function (v) {
        variantsHtml += '<button type="button" class="pair-details__variant' +
          (v.id === productData.variantId ? ' is-selected' : '') +
          '" data-variant-id="' + v.id + '"' +
          (!v.available ? ' disabled' : '') +
          ' data-price="' + v.priceFormatted + '">' + v.title + '</button>';
      });
      variantsHtml += '</div>';
    }

    var html = galleryHtml +
      '<div class="pair-details__info">' +
        '<h2 class="pair-details__title">' + productData.title + '</h2>' +
        '<span class="pair-details__price" data-pair-price>' + productData.priceFormatted + '</span>' +
        variantsHtml +
        '<div class="pair-details__description">' + productData.description + '</div>' +
        '<div class="pair-details__actions">' +
          '<button type="button" class="button button--solid--hover-accent" data-pair-drawer-add data-variant-id="' + productData.variantId + '">' +
            '<span class="button__text">Add to Cart</span>' +
          '</button>' +
        '</div>' +
      '</div>';

    contentEl.innerHTML = html;

    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    drawer.show();

    var addBtn = drawer.querySelector('[data-pair-drawer-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(addBtn.getAttribute('data-variant-id'), addBtn);
      });
    }

    drawer.querySelectorAll('.pair-details__variant').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        drawer.querySelectorAll('.pair-details__variant').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        var priceEl = drawer.querySelector('[data-pair-price]');
        if (priceEl) priceEl.textContent = btn.getAttribute('data-price');
        var addBtnInner = drawer.querySelector('[data-pair-drawer-add]');
        if (addBtnInner) addBtnInner.setAttribute('data-variant-id', btn.getAttribute('data-variant-id'));
      });
    });
  }

  /* ---------- early trigger: theme ke cart requests par foran refresh ---------- */

  function patchFetch() {
    if (window.__pairFetchPatched) return;
    window.__pairFetchPatched = true;

    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isSelf = !!(init && init.headers && init.headers['X-Pair-Self']);
      var promise = origFetch.apply(this, arguments);

      if (!isSelf && /\/cart\/(add|change|update|clear)/.test(url)) {
        setLoading(true);
        promise.then(function (res) {
          if (res && res.ok) refreshPair();
          else setLoading(false);
        }).catch(function () {
          setLoading(false);
        });
      }

      return promise;
    };
  }

  /* ---------- init ---------- */

  function isInsidePair(node) {
    var el = node && node.nodeType === 1 ? node : (node && node.parentElement);
    return !!(el && el.closest && el.closest('[data-cart-pair-it-with]'));
  }

  function init() {
    injectStyles();
    patchFetch();
    toggleWrapper();
    initButtons();

    var drawer = document.getElementById('site-cart-sidebar');
    if (!drawer) return;

    if (observer) observer.disconnect();

    // Fallback: agar theme fetch ke bajaye kisi aur tareeqe se cart update kare
    observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        return !isInsidePair(m.target);
      });
      if (relevant) scheduleRefresh();
    });

    observer.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();